import { appNabarRoutes } from "../../../router/AppNavbarRoutes";
import { PaymmentGatewayTable } from "./PaymmentGatewayTable";
import { SinglePaymmentGatewayForm } from "./SinglePaymmentGatewayForm";


export const paymentGatewayRoutes = [
    { path: appNabarRoutes.settings.paymentGateway, exact: true, element: <PaymmentGatewayTable /> },
    { path: `${appNabarRoutes.settings.paymentGateway}/create`, exact: true, element: <SinglePaymmentGatewayForm /> },
    { path: `${appNabarRoutes.settings.paymentGateway}/edit/:uuid`, exact: true, element: <SinglePaymmentGatewayForm /> },
]